export default __webpack_public_path__ + "static/media/LOGO-LINEXPERTS-COLOR.c1dd60aa.png";